import React from 'react';
import * as Icons from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data: {
    serviceName: string;
    address: string;
    date: string;
    time: string;
    isUrgent: boolean;
  };
}

export const ConfirmationModal: React.FC<Props> = ({ isOpen, onClose, onConfirm, data }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-gray-900/40 backdrop-blur-md transition-opacity" onClick={onClose} />
      
      <div className="relative bg-white rounded-[2rem] p-6 w-full max-w-sm shadow-3d animate-zoomIn overflow-hidden border border-white/50">
        {/* Decorative background element */}
        <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-blue-50/80 to-transparent pointer-events-none" />
        
        <div className="relative z-10 text-center mb-6">
          <div className="w-16 h-16 bg-white rounded-2xl shadow-lg flex items-center justify-center mx-auto mb-4 text-primary border border-gray-50 rotate-3">
            <Icons.CheckCircle2 size={32} className="drop-shadow-sm" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 leading-tight">Проверьте данные</h3>
          <p className="text-sm text-gray-500 mt-2 font-medium">Всё верно?</p>
        </div>

        <div className="space-y-3 bg-gray-50/80 p-5 rounded-2xl mb-8 border border-gray-100 relative z-10 backdrop-blur-sm">
          <div className="flex justify-between items-start gap-3">
            <span className="text-gray-500 text-sm font-medium shrink-0">Услуга</span>
            <span className="font-bold text-gray-900 text-right text-sm leading-tight">{data.serviceName}</span>
          </div>
          <div className="w-full h-px bg-gray-200/50" />
          <div className="flex justify-between items-start gap-3">
            <span className="text-gray-500 text-sm font-medium shrink-0">Адрес</span>
            <span className="font-bold text-gray-900 text-right text-sm leading-tight">{data.address}</span>
          </div>
          <div className="w-full h-px bg-gray-200/50" />
          <div className="flex justify-between items-start gap-3">
            <span className="text-gray-500 text-sm font-medium shrink-0">Время</span>
            <span className={`font-bold text-right text-sm ${data.isUrgent ? 'text-orange-500' : 'text-gray-900'}`}>
                {data.isUrgent ? 'Срочный выезд' : (
                    <>
                        {data.date ? new Date(data.date).toLocaleDateString('ru-RU') : 'Скоро'}
                        {data.time ? `, ${data.time}` : ''}
                    </>
                )}
            </span>
          </div>
        </div>

        <div className="space-y-3 relative z-10">
          <button
            onClick={onConfirm}
            className="w-full py-4 bg-gradient-to-r from-primary to-blue-600 text-white font-bold text-lg rounded-xl shadow-lg shadow-blue-500/30 active:scale-[0.98] transition-transform"
          >
            Всё верно
          </button>
          <button
            onClick={onClose}
            className="w-full py-4 bg-white text-gray-600 font-bold rounded-xl hover:bg-gray-50 active:scale-[0.98] transition-colors border border-gray-100 shadow-sm"
          >
            Редактировать
          </button>
        </div>
      </div>
    </div>
  );
};